const svgRecommendedMarker = () => {
  return `
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect 
          x="2" 
          y="2" 
          width="36" 
          height="36" 
          rx="18" 
          fill="#15B097"
      />
      <rect 
          x="2" 
          y="2" 
          width="36" 
          height="36" 
          rx="18" 
          stroke="#ffffff" 
          stroke-width="4"
      />
    </svg>
  `
}

export const recommendedMarker = () => `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgRecommendedMarker())}`

